module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ausLj"))).then(() => parcelRequire('d0iPb'));